import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthRouteWrapper = () => {
  const isAuthenticated = Boolean(localStorage.getItem("userData"));
  const userData = isAuthenticated
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const location = useLocation();
  const UserData = JSON.parse(localStorage.getItem("userData"));
  const rout = UserData?.domain || "elsnertech";
  const welcomePath = `/${rout}/welcome`;

  // If _not_ authenticated, render the nested public routes
  if (!isAuthenticated) {
    return <Outlet />;
  }

  // Build the two possible “last active” paths
  const lastId = userData?.lastActiveChat?.id;
  const msgPath = lastId ? `/${rout}/message/${lastId}` : null;
  const chPath = lastId ? `/${rout}/channels/${lastId}` : null;

  // If already on one of those, let child routes render
  if (
    location.pathname === msgPath ||
    location.pathname === chPath ||
    location.pathname === welcomePath
  ) {
    return <Outlet />;
  }

  // Otherwise, redirect an authenticated user to their last active chat
  if (
    lastId &&
    (userData?.lastActiveChat?.type === "channel" ||
      userData?.lastActiveChat?.type === "channels")
  ) {
    return <Navigate to={chPath} replace />;
  } else if (lastId) {
    return <Navigate to={msgPath} replace />;
  }

  // Default authenticated landing: welcome screen
  return <Navigate to={welcomePath} replace />;
};

export default AuthRouteWrapper;
